import { z } from '@harvestiq/zod';
import { safeUserSchema } from './user';
import { dbUserUpdateSchema } from './db-user';

export const updateUserRequestSchema = dbUserUpdateSchema.extend({
  avatarId: z.string().uuid().nullable().optional(),
});
export type UpdateUserRequest = z.infer<typeof updateUserRequestSchema>;

export const updateUserSuccessResponseSchema = safeUserSchema;
export type UpdateUserSuccessResponse = z.infer<
  typeof updateUserSuccessResponseSchema
>;

export const updateUserErrorResponseSchema = z.object({
  // TODO: errors object should be an array not string but matching existing API patterns
  errors: z.array(z.string()).or(z.string()),
});
export type UpdateUserErrorResponse = z.infer<
  typeof updateUserErrorResponseSchema
>;

export const updateUserResponseSchema = updateUserSuccessResponseSchema.or(
  updateUserErrorResponseSchema
);
export type UpdateUserResponse = z.infer<typeof updateUserResponseSchema>;
